import { Dropdown } from "@freightsimple/ui-core/Controls/Dropdown";
import type { CountryCode } from "@freightsimple/generated-dashboard-openapi-client/models/CountryCode";
import { LocationsFlag } from "../CustomComponents/LocationsFlag";

interface PostalCodeCityDropdownProps {
  cities: string[];
  selectedCity: string;
  stateOrProvinceCode: string;
  countryCode: CountryCode | undefined;
  onCitySelected: (city: string) => void;
}

function LocationsPostalCodeCityDropdown(props: PostalCodeCityDropdownProps) {
  const { cities, selectedCity, stateOrProvinceCode, onCitySelected } = props;

  const options = cities.map((city) => ({
    value: city,
    label: `${city}, ${stateOrProvinceCode}`,
    icon: <LocationsFlag countryCode={props.countryCode} />,
  }));

  return (
    <Dropdown
      value={selectedCity}
      onChange={onCitySelected}
      options={options}
      data-testid="city-dropdown"
      width="fit"
    />
  );
}

export default LocationsPostalCodeCityDropdown;
